module.exports = __webpack_public_path__ + "56040e58aa98ea7d205ee20975b37b4d.png";